/* ==========================================================================
   TRADA — Menú desplegable del encabezado (escritorio y tablet)
   Sin dependencias. Si falla el JS, los enlaces siguen siendo enlaces
   normales y el menú móvil (details/summary) sigue funcionando.
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP_NAV = '(min-width: 990px)';
  var FINE_POINTER = '(hover: hover) and (pointer: fine)';

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function matches(query) {
    return window.matchMedia ? window.matchMedia(query).matches : false;
  }

  function initHeaderNav() {
    var nav = qs('[data-nav]');
    if (!nav || nav.getAttribute('data-nav-ready') === 'true') return;

    var items = qsa('[data-nav-item]', nav);
    if (!items.length) return;

    nav.setAttribute('data-nav-ready', 'true');

    var closeTimer = null;

    // Si el panel se sale por la derecha, se ancla al borde derecho del ítem:
    // así nunca genera scroll horizontal.
    function placePanel(item) {
      var panel = qs('[data-nav-panel]', item);
      if (!panel) return;
      panel.classList.remove('header__submenu--right');
      var rect = panel.getBoundingClientRect();
      if (rect.right > window.innerWidth - 8) {
        panel.classList.add('header__submenu--right');
      }
    }

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      qsa('[data-nav-link], [data-nav-toggle]', item).forEach(function (el) {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (open) placePanel(item);
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) setOpen(item, false);
      });
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!matches(DESKTOP_NAV) || !matches(FINE_POINTER)) return;
        window.clearTimeout(closeTimer);
        closeAll(item);
        setOpen(item, true);
      });

      // Margen de gracia: el menú no se cierra de golpe al mover el cursor.
      item.addEventListener('mouseleave', function () {
        if (!matches(DESKTOP_NAV) || !matches(FINE_POINTER)) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          setOpen(item, false);
        }, 320);
      });
    });

    nav.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-nav-toggle]');
      if (toggle) {
        event.preventDefault();
        var caretItem = toggle.closest('[data-nav-item]');
        if (!caretItem) return;
        var willOpen = !caretItem.classList.contains('is-open');
        closeAll(caretItem);
        setOpen(caretItem, willOpen);
        return;
      }

      var link = event.target.closest('[data-nav-link]');
      if (!link) return;

      // Con mouse el enlace navega normal (el desplegable ya se abrió con hover).
      if (matches(FINE_POINTER)) return;

      // Táctil (tablet): primer toque abre, segundo toque cierra.
      var linkItem = link.closest('[data-nav-item]');
      if (!linkItem) return;
      event.preventDefault();
      var open = !linkItem.classList.contains('is-open');
      closeAll(linkItem);
      setOpen(linkItem, open);
    });

    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) closeAll(null);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });

    window.addEventListener('resize', function () {
      if (!matches(DESKTOP_NAV)) closeAll(null);
    });
  }

  initHeaderNav();

  // El editor de temas vuelve a renderizar la sección sin recargar la página.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-nav]')) initHeaderNav();
  });
})();
